import {parseJsonCookie} from '@smart/utils';
import {z} from 'zod';

export function getShowRoomVehicleMode(): boolean {
  if (window.sessionStorage.getItem(`showroomVehicle`) === `true`) {
    return true;
  }
  const {showroomVehicle: isShowRoomVehicle} = parseJsonCookie({
    cookieName: `smart-adb-showroom_vehicle`,
    schema: z.object({showroomVehicle: z.boolean()}),
    cookieData: document.cookie,
  }) ?? {showroomVehicle: false};

  if (isShowRoomVehicle) {
    window.sessionStorage.setItem(`showroomVehicle`, `true`);
    window.sessionStorage.removeItem(`demoVehicle`);
  }

  return isShowRoomVehicle;
}
